import React from 'react';
import Chart from 'react-google-charts';


export default class  extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
 
            }
        }



     componentDidMount(){
    }
     render() { 
       return (
          <div>

              <Chart
                width={500}
                height={300}
                chartType={'ColumnChart'}
                data={this.props.chartData}
                options={{title:this.props.charTitle}}
                />

         </div>
        );
       }
}